// extracted by mini-css-extract-plugin
module.exports = {"healthRiskFilter":"HealthRiskFilter_healthRiskFilter__JUj7V","healtRiskMenuItem":"HealthRiskFilter_healtRiskMenuItem__1O7OG"};